export default function(cbFn) {
	if (typeof cbFn === 'function') {
		/* Standard syntax */
		document.addEventListener('fullscreenchange', cbFn, false);
		/* Firefox */
		document.addEventListener('mozfullscreenchange', cbFn, false);
		/* Chrome, Safari and Opera */
		document.addEventListener('webkitfullscreenchange', cbFn, false);
		/* IE / Edge */
		document.addEventListener('msfullscreenchange', cbFn, false);
	}
};

export const isInFullscreen = () => document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
